

















import Vue from 'vue';

export default Vue.extend({
  props: {
    value: { type: String, default: '' },
    title: { type: String, default: undefined },
    message: { type: String, default: undefined },
  },
  data: () => ({
    enteredValue: '',
  }),
  mounted() {
    this.enteredValue = this.value;
    try {
      const textField = this.$refs.textField as Vue;
      const inputEl = textField.$refs.input as HTMLInputElement;
      inputEl.focus();
      this.$nextTick(() => {
        inputEl.setSelectionRange(0, inputEl.value.length);
      });
    } catch (error) {
      // not a critical error, just print to console
      this.$log.error(error);
    }
  },
  methods: {
    close(result?: string | null) {
      // Same behaviour as window.prompt
      this.$emit('input', result ?? null);
      this.$el.remove();
      this.$destroy();
    },
  },
});
